// extracted by mini-css-extract-plugin
export var section = "index-module--section--2C928";
export var sectionBackground = "index-module--sectionBackground--310N9";
export var title = "index-module--title--3n6Zi";
export var paragraphContainer = "index-module--paragraphContainer--33pX9";